const validationMixins = {
    props: {
        aggregator: {
            type: Object,
        },
    },
    methods: {
        getValidationAggregatorDefinition() {
            return null;
        },
    },
    created() {
        if (this.aggregator) {
            this.aggregator.registerComponent(this.getValidationAggregatorDefinition());
        } else {
            throw new Error('Validation aggregator is not present in this component');
        }
    },
};

export default validationMixins;
